import * as React from "react";
import { Box, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import { formatDateToSecond } from "../util/helper"
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const TableImportData = ({rows, columns, handleDownload, loading}) => {

  return (
    <Box
      sx={{
        backgroundColor: "#f1f9ff",
        borderRadius: "4px",
      }}
    >
      <Box width="100%">
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#f1f9ff",
            borderRadius: "none",
            boxShadow: "none",
          }}
        >
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns?.map((colum) => (
                  <TableCell
                    key={colum.field}
                    sx={{
                      // width:`${colum.width}`,
                      cursor: "pointer",
                      borderBottom: "1px solid #808182 !important",
                    }}
                  >
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "#707070",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {colum?.headerName}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loading?"":<TableBody sx={{ position: "relative" }}>
              {rows?.map((row, index) => (
                <TableRow
                  key={`${row.file_name}-${index}`}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "td, th": {
                      color: "#707070",
                      fontWeight: "bold",
                      fontSize: "16px",
                    },
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ width: "40%", wordBreak: "break-all" }}
                  >
                    {row.file_name}
                  </TableCell>
                  <TableCell sx={{ width: "40%"}}>
                    {formatDateToSecond(row.created)}
                  </TableCell>
                  <TableCell>
                    <CloudDownloadIcon onClick={() => handleDownload(row)} fontSize="large"/>
                  </TableCell>
                  
                </TableRow>
              ))}
            </TableBody>}
          </Table>
          {loading?<Box
            sx={{
              position: "relative",
              width: "100%",
              height: "160px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <CircularProgress sx={{ color: "#2699fb" }} />
            </Box>
          </Box>:""}
        </TableContainer>
      </Box>
      <Box width="100%" padding="10px 0px" position="relative">
        {rows?.length ? (
          <p></p>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
  );
};

export default TableImportData;
